import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { Applicant, ApplicationProps, Bank } from '../../redux-store/types/api-types';
import { KeyValue } from './contributor';
import { Gridstyles } from './index';
import { SubHeading } from '../investors/components';
import {
  checkIfApplicationIsIndividual,
  getBankAddress,
  partitionArray,
} from '../../utils/utilityFunctions';
import { styles } from '../../Styles/styles';

function CommenBankDetails({
  banks,
  application,
  bankTitle = "Contributor's Bank Details",
  topupbank = false,
}: {
  banks: Partial<Bank>[];
  application: ApplicationProps;
  bankTitle?: string;
  topupbank?: boolean;
}): JSX.Element {
  return (
    <>
      <Typography
        component="h2"
        sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
        {bankTitle}
      </Typography>
      {banks?.length === 0 ? (
        <Grid
          xs={12}
          sm={12}
          sx={{
            fontSize: 18,
            fontWeight: 600,
            color: 'common.black',
            textAlign: 'center',
            my: 3,
          }}>
          No Bank Details
        </Grid>
      ) : (
        banks
          ?.sort((bank1, bank2) => {
            return Number(bank1.applicantId) - Number(bank2.applicantId);
          })
          ?.map((bank, index: number) => {
            const title = [
              'Primary Contributor Details',
              'Joint Contributor 1 Details',
              'Joint Contributor 2 Details',
            ][index];
            const bankAddress = getBankAddress(bank.address1, bank.address2, bank.address3);
            const mappedApplicantName = application?.applicants?.find(
              (applicant) => Number(applicant.id) === Number(bank.applicantId)
            )?.name;
            const displayBankDetails = (application?.applicants?.find(
              (applicant) => Number(applicant.id) === Number(bank.applicantId)
            ) || {})[topupbank ? 'wishToContributeTopup' : 'wishToContribute'];
            return (
              <React.Fragment key={bank.id}>
                {checkIfApplicationIsIndividual(application?.applicationType || '') && (
                  <SubHeading sx={{ letterSpacing: 0.5 + 'px' }}>{title}</SubHeading>
                )}
                <Gridstyles>
                  <Grid
                    item
                    container
                    pt={2}
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue title={'Contributor Name'} description={mappedApplicantName} />
                    {!displayBankDetails && (
                      <Grid item xs={12} display="flex" alignItems={'flex-start'}>
                        {/* <Checkbox defaultChecked disabled={true} /> */}
                        <Typography
                          sx={{
                            fontSize: 15,
                            fontWeight: 700,
                            color: 'rgba(0, 0, 0, 0.6)',
                            letterSpacing: '0.5px',
                          }}>
                          {`I do not wish to contribute`}
                        </Typography>
                      </Grid>
                    )}
                    {displayBankDetails && (
                      <>
                        <KeyValue title={'IFSC Code'} description={bank.ifscCode} />
                        <KeyValue
                          title={'Bank Account Number'}
                          description={bank.bankAccountNumber}
                        />
                        <KeyValue title={'MICR Code'} description={bank.micrCode} />
                        <KeyValue title={'Bank Type'} description={bank.bankAccountType} />
                        <KeyValue title={'Bank Name'} description={bank.bankName} />
                        <KeyValue title={'Branch Name'} description={bank.bankBranch} />
                        <KeyValue
                          title={`Bank Address`}
                          description={`${bankAddress}`}
                          sx={{
                            textTransform: 'capitalize',
                          }}
                        />
                        <KeyValue
                          title={`Default Bank Account`}
                          description={bank.defaultBankAccount ? 'Yes' : '-'}
                        />
                        <KeyValue
                          title={`Penny Drop Verified`}
                          description={
                            bank.pennydropCheck ? (bank.pennydropVerified ? 'Yes' : 'No') : '-'
                          }
                        />
                      </>
                    )}
                  </Grid>
                </Gridstyles>
              </React.Fragment>
            );
          })
      )}
    </>
  );
}

export default function BankDetails({
  banks = [],
  displayTopUpBanks = false,
  application,
}: {
  banks: Partial<Bank>[];
  displayTopUpBanks: boolean | null;
  application: ApplicationProps;
}): JSX.Element {
  const [topUpBanks, normalBanks] = partitionArray(banks);
  return (
    <>
      <Box sx={styles.ApplicationDetailsCommonLayout} mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <CommenBankDetails banks={normalBanks} application={application} />
            {displayTopUpBanks && (
              <CommenBankDetails
                banks={topUpBanks}
                bankTitle={`Contributor's Top Up Bank Details`}
                application={application}
                topupbank={true}
              />
            )}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
